import { useStandortContext } from '@/features/standortContext/StandortContext';
import { managerV1BaseUrl } from '@/utils';
import { ReactNode, useEffect } from 'react';

const NavigateToV1 = () => {
  useEffect(() => {
    window.location.replace(managerV1BaseUrl);
  }, []);
  return <></>;
};

export function WithFeatureFlags({
  children,
  name,
  Fallback,
}: {
  children: ReactNode;
  name: string;
  Fallback?: ReactNode;
}) {
  const { currentStandort } = useStandortContext();

  const currentFeatureFlag = currentStandort?.featureFlags.find(
    (flag) => flag.name === name,
  );

  if (currentFeatureFlag && currentFeatureFlag.isActive) {
    return children;
  }

  return Fallback ? Fallback : <NavigateToV1 />;
}
